import { Component, OnInit } from '@angular/core';
import { TenantService } from '../../../core/tenant/tenant.service';

@Component({
  selector: 'kt-phone-warning',
  templateUrl: './phone-warning.component.html',
  styleUrls: ['./phone-warning.component.scss']
})
export class PhoneWarningComponent implements OnInit {

  constructor(
    public tenant: TenantService
  ) { }

  ngOnInit(): void {
  }

}
